var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5074_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0H3.50016C1.57538 0 0.000244141 1.57513 0.000244141 3.49991V10.5001C0.000244141 12.4244 1.57538 14 3.50016 14H10.5C12.4248 14 13.9999 12.4244 13.9999 10.5001V3.49991C13.9999 1.57513 12.4248 0 10.5 0ZM12.8332 10.5001C12.8332 11.7863 11.7869 12.8333 10.5 12.8333H3.50016C2.21377 12.8333 1.16694 11.7863 1.16694 10.5001V3.49991C1.16694 2.21335 2.21377 1.1667 3.50016 1.1667H10.5C11.7869 1.1667 12.8332 2.21335 12.8332 3.49991V10.5001Z",
    fill: "#1485a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7922 4.08321C11.2755 4.08321 11.6672 3.69147 11.6672 3.20823C11.6672 2.72499 11.2755 2.33325 10.7922 2.33325C10.309 2.33325 9.91724 2.72499 9.91724 3.20823C9.91724 3.69147 10.309 4.08321 10.7922 4.08321Z",
    fill: "#1485a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 3.49988C5.06655 3.49988 3.5 5.0666 3.5 6.99979C3.5 8.93226 5.06655 10.5 6.99991 10.5C8.93273 10.5 10.4998 8.93226 10.4998 6.99979C10.4998 5.0666 8.93273 3.49988 6.99991 3.49988ZM6.99991 9.33335C5.71141 9.33335 4.66669 8.28864 4.66669 6.99979C4.66669 5.71094 5.71141 4.66657 6.99991 4.66657C8.28842 4.66657 9.33313 5.71094 9.33313 6.99979C9.33313 8.28864 8.28842 9.33335 6.99991 9.33335Z",
    fill: "#1485a6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5074_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b7fbf66e1630683d7e421245b7226816.svg";
export { ForwardRef as ReactComponent };